import { cn } from '@/lib/cn'

/* The fact cell the case-detail sections share: eyebrow label over value.
 *
 * It lives in a neutral folder rather than inside `overview/`, where its only
 * other reader would have to reach past an index, because BOTH the overview's
 * details card and the leg card build their grids out of it and the two must
 * keep rendering identically. `money/`, `legs/` and `overview/` each export
 * exactly their section and nothing else; importing `overview/Fact` from
 * `legs/` would breach that discipline and assert a `legs → overview`
 * dependency that does not otherwise exist. Siblings sharing a primitive keep
 * it beside them, not inside one of themselves.
 *
 * Until this file existed there were two byte-identical copies — one in
 * `CaseSections.tsx`, one in `legs/Fact.tsx` — held in step by a comment
 * asking the next reader not to let them diverge. This is that one copy. */

/** One fact: eyebrow label over value. Labels above values wrap gracefully in
 *  BOTH languages — a fixed label column measured against English is exactly
 *  how «Условия оплаты» ends up three lines deep (UX-DR-30). */
export function Fact({
  label,
  wide = false,
  children,
}: {
  label: string
  /** Long prose values (payment terms) take the full row. */
  wide?: boolean
  children: React.ReactNode
}) {
  return (
    <div className={cn('flex min-w-0 flex-col gap-1.5', wide && 'sm:col-span-2')}>
      <span className="asa-eyebrow whitespace-nowrap">{label}</span>
      <span className="text-text-body min-w-0 text-[13px] leading-snug font-normal">
        {children}
      </span>
    </div>
  )
}
